// extracted by mini-css-extract-plugin
export var alert = "alert-module--alert--75c22";
export var content = "alert-module--content--d0044";
export var customIcon = "alert-module--customIcon--817f6";
export var error = "alert-module--error--64a67";
export var icon = "alert-module--icon--f03cc";
export var slideLeft = "alert-module--slide-left--dac97";
export var success = "alert-module--success--93fd4";
export var svgContainer = "alert-module--svgContainer--47814";
export var timesButton = "alert-module--timesButton--f6ac7";
export var title = "alert-module--title--4228c";
export var warning = "alert-module--warning--b899a";